import React from "react";

import { connect } from "react-redux";
import * as actionCreators from "../../../Store/actions/index";
import classes from "./DealerCard.module.css";
import Yellowstar from "../../../assets/svg/Yellowstar.svg";
import EmptyYellowstar from "../../../assets/svg/EmptyYellowstar.svg";
import message from "../../../assets/svg/message.svg";
import dealerImg from "../../../assets/Img/unKnownDealer.jpg";

const DealerCard = (props) => {
    let dealer = null
    if (props.dealer) {
        dealer = (
            <div className={classes.Container}>
                <div className={classes.DealerCard}>
                    <img src={props.dealer.profile_picture ? props.dealer.profile_picture : dealerImg} alt='' />
                    <div className={classes.DealerDetila}>
                        <h2>{props.dealer.name}</h2>
                        <p> {props.dealer.dealership_type}   {props.dealer.dealership_type === 'Company' ? ': ' + props.dealer.company_name : null}</p>
                        <div>
                            <img src={Yellowstar} alt='' />
                            <img src={Yellowstar} alt='' />
                            <img src={Yellowstar} alt='' />
                            <img src={Yellowstar} alt='' />
                            <img src={Yellowstar} alt='' />
                            <img src={EmptyYellowstar} alt='' />
                        </div>
                    </div>
                </div>
                <div className={classes.DealerCard}>
                    <div className={classes.DealerDetilaA}>
                        <p> Address : {props.dealer.phone}</p>
                        <p> Tel : {props.dealer.phone}</p>
                        <p> posts : {props.dealerPostsLength}</p>
                    </div>
                </div>
                <div className={classes.Btn}>
                    <button onClick={() => {
                        props.onToggelContactNow(props.dealer.id, props.dealer.name, props.dealer.phone)
                    }}><img src={message} alt='' /></button>
                </div>
            </div>

        )
    }
    return (
        dealer
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onToggelContactNow: (id, name, phone) => { dispatch(actionCreators.toggelContactShow(id, name, phone)) }
    }
};

export default connect(null, mapDispatchToProps)(DealerCard);